import React from 'react'
import { Link } from 'react-router-dom'

import logo from '../assets/images/logo-dark.svg'
import Lookup from '../features/lookup/lookup'
import { Session } from './types'
import MenuHeader from './menuHeader'

export interface HeaderProps {
  session: Session
}

export const Header = ({ session }: HeaderProps) => {
  const { isAuth } = session
  const handleRedirect = () => {
    window.location.href = '/'
  }

  if (!isAuth)
    return (
      <div className="header">
        <Link className="header__item--left" to="/">
          <img
            src={logo}
            alt="Blinker"
            className="header__logo"
            width={139}
            height={40}
          />
        </Link>
      </div>
    )

  return (
    <div className="header">
      <div className="header__item--left" onClick={handleRedirect}>
        <img
          src={logo}
          alt="Blinker"
          className="header__logo"
          width={139}
          height={40}
        />
      </div>

      <Lookup />
      <MenuHeader user={session.user} />
    </div>
  )
}

Header.displayName = 'Header'
